import React from 'react'
import { Outlet } from 'react-router-dom'
import "../views/auth/AuthPages.css"

export default function auth() {
  return (
    <section className="auth-layout">
      <Outlet />
    </section>
  )
}
